import { computed, makeObservable } from 'mobx';

import { inject, injectable } from '@servicetitan/react-ioc';
import {
    MarketingMfe,
    MarketingRouteStore,
    MarketingSection,
    MfeBasenames,
} from '@servicetitan/marketing-global-route';
import { StandaloneRootStore } from '@servicetitan/standalone-root';

import { AppStore } from '../../../common/stores/app.store';

@injectable()
export class RevenueAttributionStore {
    basename = this.routeStore.getPathnameWithStandaloneRoot(
        MarketingSection.Settings,
        MfeBasenames[MarketingMfe.RevenueAttribution],
    );

    @computed get source() {
        return `https://unpkg.servicetitan.com/@servicetitan/marketing-attribution@${this.standaloneRootStore.appSettings.environmentTag}`;
    }

    @computed get data() {
        return {
            ...this.appStore.defaultMFEData,
        };
    }

    constructor(
        @inject(AppStore) private readonly appStore: AppStore,
        @inject(StandaloneRootStore) private readonly standaloneRootStore: StandaloneRootStore,
        @inject(MarketingRouteStore) private readonly routeStore: MarketingRouteStore,
    ) {
        makeObservable(this);
    }
}
